<!-- @format -->

<template>
	<div class="container">
		<h1 class="flex items-center">
			<base-modal v-show="!loading" ref="createRoundModal">
				<round-form @courses-loaded="loading = false" @round-saved="roundSaved"></round-form>
				<template v-slot:modal-button="{ showModal }">
					<button @click="showModal" class="button is-small mr-1">
						<font-awesome-icon icon="plus" />
					</button>
				</template>
			</base-modal> Rounds
		</h1>
		<base-round-list ref="roundList" @loaded="loading = false"></base-round-list>
	</div>
</template>

<script>
/** @format */
import CourseFields from '@/fields/courses';

export default {
	name: 'Rounds',
	components: {
		'round-form': () => import(/* webpackChunkName: "RoundForm" */ './../components/Forms/Round')
	},
	methods: {
		roundSaved(round) {
			this.$refs.createRoundModal.closeModal();
			this.$refs.roundList.refresh();
		}
	},
	data() {
		return {
			loading: true
		};
	}
};
</script>
